import { render, staticRenderFns } from "./SummaryTable.vue?vue&type=template&id=811cc55c&scoped=true&"
import script from "./SummaryTable.vue?vue&type=script&lang=ts&"
export * from "./SummaryTable.vue?vue&type=script&lang=ts&"
import style0 from "./SummaryTable.vue?vue&type=style&index=0&id=811cc55c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "811cc55c",
  null
  
)

export default component.exports